module.exports = __webpack_public_path__ + "img/icon-filter.9b96e9e5.svg";